import { KlaviyoForm } from '@theme/klaviyo-form';

/** Consult-booking signup in the inline panel. Tag name only; behavior is `KlaviyoForm`. */
class InlineSignupForm extends KlaviyoForm {}

if (!customElements.get('inline-signup-form')) {
  customElements.define('inline-signup-form', InlineSignupForm);
}
